module.exports = __webpack_public_path__ + "static/media/0013.61c2f4ea.svg";